export interface SampleDocument {
  id: string;
  title: string;
  description: string;
  category: string;
  documentType: string;
  yearLevel: string;
  curriculum: string;
  subject: string;
  topic: string;
  fileSize: string;
  preview: string;
  downloadUrl: string;
  slideDownloadUrl?: string;
  worksheetDownloadUrl?: string;
}

export const sampleDocuments: SampleDocument[] = [
  {
    id: "y3-lesson-plan",
    title: "Year 3 Maths",
    description: "An introduction to understanding multiplication as repeated addition using arrays, equal groups and skip counting.",
    category: "Teaching Programs & Slides",
    documentType: "Lesson Plan",
    yearLevel: "Year 3",
    curriculum: "Australian",
    subject: "Mathematics",
    topic: "Multiplication",
    fileSize: "~250KB",
    preview: "Detailed lesson structure covering multiplication concepts with hands-on activities, learning intentions, and success criteria designed for Year 3 students.",
    downloadUrl: "/downloadables/Sample Y3 Lesson Plan - Multiplication (AU).docx",
    slideDownloadUrl: "/downloadables/Sample - Year 3 Maths Slides.pptx",
    worksheetDownloadUrl: "/downloadables/Sample - Year 3 Maths Worksheet.docx"
  },
  {
    id: "foundation-lesson-plan",
    title: "Foundation English",
    description: "Students identify the middle, beginning and end of 'The Very Cranky Bear' and create an oral retell with puppet play.",
    category: "Teaching Programs & Slides",
    documentType: "Lesson Plan",
    yearLevel: "Foundation",
    curriculum: "Australian",
    subject: "English",
    topic: "Narrative Retell",
    fileSize: "~230KB",
    preview: "Foundation-appropriate lesson plan with scaffolded activities for developing narrative retelling skills, including visual supports and assessment rubrics.",
    downloadUrl: "/downloadables/Sample Foundation Lesson Plan - Narrative Retell (AU).docx",
    slideDownloadUrl: "/downloadables/Sample - Foundation English Slides.pptx",
    worksheetDownloadUrl: "/downloadables/Sample - Foundation English Worksheet.docx"
  },
  {
    id: "stage-1-science-unit",
    title: "Stage 1 Science",
    description: "A series of five lessons for Years 1 and 2, investigating push and pull forces with hands-on investigations.",
    category: "Teaching Programs & Slides",
    documentType: "Unit of Work",
    yearLevel: "Stage 1",
    curriculum: "NSW",
    subject: "Science",
    topic: "Push and Pull Forces",
    fileSize: "~280KB",
    preview: "Comprehensive unit of work exploring push and pull forces through practical investigations, aligned to NSW Science syllabus with detailed weekly breakdowns.",
    downloadUrl: "/downloadables/Sample Stage 1 Science Unit of Work - Push and Pull Forces (NSW).docx",
    slideDownloadUrl: "/downloadables/Sample - Stage 1 Science Slides.pptx",
    worksheetDownloadUrl: "/downloadables/Sample - Stage 1 Science Worksheet.docx"
  },
  {
    id: "behaviour-support-plan",
    title: "Behaviour Support Plan",
    description: "Example behaviour support plan with a personalised goal and evidence-based strategies, suggested by AI.",
    category: "Individual Plans",
    documentType: "Sample Plan",
    yearLevel: "All Years",
    curriculum: "Universal",
    subject: "Wellbeing",
    topic: "Behaviour Support",
    fileSize: "~200KB",
    preview: "Professional template with structured sections for behaviour analysis, intervention strategies, and progress monitoring, designed for collaborative team use.",
    downloadUrl: "/downloadables/Sample - Behaviour Support Plan.docx"
  },
  {
    id: "learning-support-plan",
    title: "Learning Support Plan",
    description: "Example personalised support plan with completely personalised goals and strategies, aligned to curriculum and learning progressions.",
    category: "Individual Plans",
    documentType: "Sample Plan",
    yearLevel: "All Years",
    curriculum: "Universal",
    subject: "Special Education",
    topic: "Learning Support",
    fileSize: "~220KB",
    preview: "Comprehensive planning document with sections for learning goals, adjustments, support strategies, and progress tracking for students with additional needs.",
    downloadUrl: "/downloadables/Sample Personalised Learning & Support Plan.docx"
  }
];
